// src/pages/UserPage/sections/rideShare/rideShareUtils.js

export const DEFAULT_RIDESHARE = { active: false, regularRoutes: [] };

// ── Occurrence ────────────────────────────────────────────────────────────────
export const OCCURRENCE = {
  ANY:     'any',
  WEEKEND: 'weekend',
  CUSTOM:  'custom',
};

export const OCCURRENCE_OPTIONS = [
  { value: OCCURRENCE.ANY,     label: 'Saa ehdottaa'  },
  { value: OCCURRENCE.WEEKEND, label: 'Viikonloppuna' },
  { value: OCCURRENCE.CUSTOM,  label: 'Oma ajankohta' },
];

export const OCCURRENCE_LABELS = {
  [OCCURRENCE.ANY]:     'Saa ehdottaa',
  [OCCURRENCE.WEEKEND]: 'Viikonloppuna',
};

export const PRICE_FALLBACK = 'Omantunnon mukaan';

export const EMPTY_ROUTE = {
  origin: '',
  destination: '',
  occurrence: OCCURRENCE.ANY,
  date: '',
  time: '',
  price: '',
};

// Accepts /profiili?kimppakyyti, ?rideshare, ?tab=kimppakyyti, ?section=rideshare, #kimppakyyti
export const DEEPLINK_KEYS   = ['kimppakyyti', 'rideshare', 'ridesharing', 'kimppa'];
export const DEEPLINK_VALUES = ['kimppakyyti', 'rideshare', 'ridesharing', 'kimppa'];

export const newId = () =>
  (typeof crypto !== 'undefined' && crypto.randomUUID)
    ? crypto.randomUUID()
    : `r_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 7)}`;

/**
 * Routes saved before `occurrence` existed only had a date. Derive it so old
 * docs keep rendering correctly without a migration.
 */
export const routeOccurrence = (route) =>
  route?.occurrence || (route?.date ? OCCURRENCE.CUSTOM : OCCURRENCE.ANY);

/** Human-readable timing for a route — the chip label on the card. */
export const formatOccurrence = (route) => {
  const occ = routeOccurrence(route);
  if (occ !== OCCURRENCE.CUSTOM) return OCCURRENCE_LABELS[occ] || OCCURRENCE_LABELS[OCCURRENCE.ANY];
  if (!route?.date) return OCCURRENCE_LABELS[OCCURRENCE.ANY];
  const d = new Date(route.date);
  if (Number.isNaN(d.getTime())) return route.date; // free-text fallback
  return d.toLocaleDateString('fi-FI', { day: 'numeric', month: 'numeric', year: 'numeric' });
};

export const formatPrice = (value) => {
  if (value === '' || value === null || value === undefined) return PRICE_FALLBACK;
  const n = Number(String(value).replace(',', '.'));
  if (Number.isNaN(n)) return String(value);
  return `${n.toLocaleString('fi-FI')} €`;
};

/**
 * Normalise a draft into a stored route.
 * Only `custom` carries a date; time only rides along with a date.
 * A `custom` draft with no date collapses back to `any` — there's nothing to store.
 */
export const toRoute = (draft, id) => {
  const wantsCustom = draft.occurrence === OCCURRENCE.CUSTOM && Boolean(draft.date);
  const occurrence  = wantsCustom
    ? OCCURRENCE.CUSTOM
    : (draft.occurrence === OCCURRENCE.WEEKEND ? OCCURRENCE.WEEKEND : OCCURRENCE.ANY);

  return {
    id: id || newId(),
    origin:      draft.origin.trim(),
    destination: draft.destination.trim(),
    occurrence,
    date:  wantsCustom ? draft.date : null,
    time:  wantsCustom ? (draft.time || null) : null,
    price: String(draft.price ?? '').trim(),
  };
};

/** Stored route → dialog draft (fields must be controlled strings). */
export const toDraft = (route) => ({
  origin:      route?.origin      || '',
  destination: route?.destination || '',
  occurrence:  routeOccurrence(route),
  date:        route?.date        || '',
  time:        route?.time        || '',
  price:       route?.price ?? '',
});